import { TransportRepresentation, TransportScope } from "../../common/model/transport.model";

export enum TransportPlanningType {
    DEFAULT = 'DEFAULT', TIMEFRAME = 'TIMEFRAME', IN_ADVANCE = 'IN_ADVANCE'
}

export enum CTransportTaskState {
    NONE = 'NONE', ANY = 'ANY', IMPORTANT = 'IMPORTANT'
}

export enum TransportType {
    TRANSPORT = 'TRANSPORT', VEHICLE = 'VEHICLE'
}

export enum TransportManagementLevel {
    LIFECYCLE = 'LIFECYCLE', LOCATION = 'LOCATION'
}

// TODO YARD-3051
export class TransportDetails implements TransportRepresentation{
    id: number;
    // Autocomplete
    carrier: string;
    // Autocomplete
    supplier: string;
    driver: string;
    coDriver: string;
    // Autocomplete
    numberPlate: string;
    trailerNumberPlate: string;
    trailerIdentifier: string;
    swapTrailerNumber: string;
    orderReference: string;
    // Autocomplete
    string1: string;
    string2: string;
    phone: string;
    identityCard: string;
    dataProtectionRuleId: number;
    urgent: boolean;
    important: boolean;
    dangerousGoods: boolean;
    planningType = TransportPlanningType.DEFAULT;
    timeframeDate: string;
    inAdvanceDate: string;
    preloading: boolean;
    preloadingDate: string;
    delayedLeave: boolean;
    intermitted: boolean;
    registerNow: boolean;
    registerNowEnabled: boolean;
    pickupTruckEnabled: boolean;
    pickupTruckNumberPlate: string;
    pickupTruckTime: string;
    useGlobalConnect: boolean;
    useSms: boolean;
    messagingLanguage: string;

    // readonly attribute
    identifier: string;
    cargo: string;
    currentRoutingPositionCargo: string;
    currentRoutingPositionHint: string;
    currentRoutingPositionName: string;
    currentRoutingPositionOptionValues: string;
    currentRoutingPositionStart: string;
    transportOptionMarks: string;
    entranceDate: string;
    leaveDate: string;
    planningDate: string;
    waitingTime: string;
    processingTime: string;
    nextProcessingPositionCargo: string;
    nextProcessingPositionName: string;
    nextProcessingPositionHint: string;
    nextProcessingPositionOptionValues: string;
    processingTimeCurrentProcessing: string;
    currentPositionDuration: string;
    transportScope: TransportScope;
    messagingAvailable: boolean;
    transportName: string;
    waitingForPulling: boolean;
    waitingOnRamp: boolean;
    pendingTaskState: CTransportTaskState;
    processingDurationCritical: boolean;
    processingDurationExceeded: boolean;
    inUmbrueckung: boolean;
    staysOnYardAsVehicle: boolean;
    timeSlotDelay: number;
    managementLevel: TransportManagementLevel;
    vehicleTypeDictionaryKey: string;
    loadingTypeDictionaryKey: string;

    currentPositionIfsStatus1: string;
    currentPositionIfsStatus2: string;

    nextPositionFirstTimeSlotStart: string;
	nextPositionLastTimeSlotEnd : string;

    internal: boolean;

    get name() : string {
        return this.identifier;
    }

    get scope() : TransportScope {
        return this.transportScope;
    }

    constructor(details?: any) {
        this.update(details);
    }

    public update(details: any) {
        this.id = details?.id;
        this.carrier = details?.carrier;
        this.supplier = details?.supplier;
        this.driver = details?.driver;
        this.coDriver = details?.coDriver;
        this.numberPlate = details?.numberPlate;
        this.trailerNumberPlate = details?.trailerNumberPlate;
        this.trailerIdentifier = details?.trailerIdentifier;
        this.swapTrailerNumber = details?.swapTrailerNumber;
        this.orderReference = details?.orderReference;
        this.string1 = details?.string1;
        this.string2 = details?.string2;
        this.phone = details?.phone;
        this.identityCard = details?.identityCard;
        this.dataProtectionRuleId = details?.dataProtectionRuleId;
        this.urgent = details?.urgent;
        this.important = details?.important;
        this.dangerousGoods = details?.dangerousGoods;
        this.planningType = details?.planningType;
        this.timeframeDate = details?.timeframeDate;
        this.inAdvanceDate = details?.inAdvanceDate;
        this.preloading = details?.preloading;
        this.preloadingDate = details?.preloadingDate;
        this.delayedLeave = details?.delayedLeave;
        this.intermitted = details?.intermitted;
        this.registerNow = details?.registerNow;
        this.registerNowEnabled = details?.registerNowEnabled;
        this.pickupTruckEnabled = details?.pickupTruckEnabled;
        this.pickupTruckNumberPlate = details?.pickupTruckNumberPlate;
        this.pickupTruckTime = details?.pickupTruckTime;
        this.useGlobalConnect = details?.useGlobalConnect;
        this.useSms= details?.useSms;
        this.messagingLanguage = details?.messagingLanguage;
        this.identifier = details?.identifier;
        this.cargo = details?.cargo;
        this.currentRoutingPositionCargo = details?.currentRoutingPositionCargo;
        this.currentRoutingPositionHint = details?.currentRoutingPositionHint;
        this.currentRoutingPositionName = details?.currentRoutingPositionName;
        this.currentRoutingPositionOptionValues = details?.currentRoutingPositionOptionValues;
        this.currentRoutingPositionStart = details?.currentRoutingPositionStart;
        this.transportOptionMarks = details?.transportOptionMarks;
        this.entranceDate = details?.entranceDate;
        this.leaveDate = details?.leaveDate;
        this.planningDate = details?.planningDate;
        this.waitingTime = details?.waitingTime;
        this.processingTime = details?.processingTime;
        this.nextProcessingPositionCargo = details?.nextProcessingPositionCargo;
        this.nextProcessingPositionName = details?.nextProcessingPositionName;
        this.nextProcessingPositionHint = details?.nextProcessingPositionHint;
        this.nextProcessingPositionOptionValues = details?.nextProcessingPositionOptionValues;
        this.processingTimeCurrentProcessing = details?.processingTimeCurrentProcessing;
        this.currentPositionDuration = details?.currentPositionDuration;
        this.transportScope = details?.transportScope;
        this.messagingAvailable = details?.messagingAvailable;
        this.transportName = details?.transportName;
        this.waitingForPulling = details?.waitingForPulling;
        this.waitingOnRamp = details?.waitingOnRamp;
        this.pendingTaskState = details?.pendingTaskState;
        this.processingDurationCritical = details?.processingDurationCritical;
        this.processingDurationExceeded = details?.processingDurationExceeded;
        this.inUmbrueckung = details?.inUmbrueckung;
        this.staysOnYardAsVehicle = details?.staysOnYardAsVehicle;
        this.timeSlotDelay = details?.timeSlotDelay;
        this.managementLevel = details?.managementLevel;
        this.vehicleTypeDictionaryKey = details?.vehicleTypeDictionaryKey;
        this.loadingTypeDictionaryKey = details?.loadingTypeDictionaryKey;
        this.currentPositionIfsStatus1 = details?.currentPositionIfsStatus1;
        this.currentPositionIfsStatus2 = details?.currentPositionIfsStatus2;
        this.nextPositionFirstTimeSlotStart = details?.nextPositionFirstTimeSlotStart;
        this.nextPositionLastTimeSlotEnd = details?.nextPositionLastTimeSlotEnd;
        this.internal = details?.internal;
    }
}

export class Field {
    key: string;
    // Wenn nur der dictionaryKey gesetzt ist handelt es sich um ein label.
    dictionaryKey: string;
    minLength = 0;
    required = false;
    readonly = false;
    identifier?: string;

    constructor(field?: any) {
        if (field != null) {
            this.key = field.key;
            this.dictionaryKey = field.dictionaryKey;
            this.minLength = field.minLength;
            this.required = field.required;
            this.readonly = field.readonly;
            this.identifier = field.identifier;
        }
    }
}

export class LayoutSection {
    fields = new Array<Field>();

    constructor(section?: any) {
        if (section != null && section.fields) {
            for (const field of section.fields) {
                this.fields.push(new Field(field));
            }
        }
    }
}

export class LayoutDefinition {

    dictionaryBase: string;
    propertyId: any;
    sections = new Array<LayoutSection>();

    constructor(model?: any) {
        if (model != null) {
            for (const section of model.sections) {
                this.sections.push(new LayoutSection(section));
            }
        }
    }
}
